// src/components/DetalhesModal.js
import React, { useState, useEffect } from 'react';
import { custosAPI } from '../services/api';

function DetalhesModal({ oportunidade, onClose, onRecarregar }) {
  const [custos, setCustos] = useState([]);
  const [mostrarFormCusto, setMostrarFormCusto] = useState(false);
  const [novoCusto, setNovoCusto] = useState({
    fornecedor_nome: '',
    servico_descricao: '',
    valor: '',
    data_vencimento: '',
    observacoes: ''
  });

  useEffect(() => {
    carregarCustos();
  }, []);

  const carregarCustos = async () => {
    try {
      const response = await custosAPI.listarPorOportunidade(oportunidade.id);
      setCustos(response.data.data || []);
    } catch (error) {
      console.error('Erro ao carregar custos:', error);
    }
  };

  const handleAdicionarCusto = async (e) => {
    e.preventDefault();
    
    try {
      await custosAPI.adicionar({
        oportunidade_id: oportunidade.id,
        ...novoCusto,
        valor: parseFloat(novoCusto.valor)
      });
      
      alert('✓ Custo adicionado com sucesso!');
      setMostrarFormCusto(false);
      setNovoCusto({
        fornecedor_nome: '',
        servico_descricao: '',
        valor: '',
        data_vencimento: '',
        observacoes: ''
      });
      await carregarCustos();
      await onRecarregar();
    } catch (error) {
      console.error('Erro ao adicionar custo:', error);
      alert('Erro ao adicionar custo');
    }
  };

  const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valor || 0);
  };

  const formatarData = (data) => {
    if (!data) return '';
    return new Date(data).toLocaleDateString('pt-BR');
  };

  const totalCustos = custos.reduce((sum, c) => sum + parseFloat(c.valor || 0), 0);
  const valorVenda = parseFloat(oportunidade.valor_real) || 0;
  const margem = valorVenda - totalCustos;
  const percentualMargem = valorVenda > 0 ? ((margem / valorVenda) * 100).toFixed(0) : 0;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{oportunidade.titulo}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body">
          {/* Informações Gerais */}
          <div className="info-section">
            <h3>Informações Gerais</h3>
            <div className="info-grid">
              <div className="info-item">
                <label>Cliente Cadastrado:</label>
                <span>{oportunidade.cliente_nome}</span>
              </div>
              {/* Extrai nome solicitado da solução MALU */}
              {(() => {
                const solucao = oportunidade.descricao || '';
                const match = solucao.match(/👤 Cliente: (.+)/);
                const nomeSolicitado = match ? match[1].trim() : null;
                
                // Só mostra se for diferente do cadastrado
                if (nomeSolicitado && nomeSolicitado !== oportunidade.cliente_nome) {
                  return (
                    <div className="info-item">
                      <label>Solicitado para:</label>
                      <span style={{color: '#2196F3', fontWeight: 'bold'}}>
                        📱 {nomeSolicitado}
                      </span>
                    </div>
                  );
                }
                return null;
              })()}
              <div className="info-item">
                <label>Status:</label>
                <span className="badge">{oportunidade.status}</span>
              </div>
              <div className="info-item">
                <label>Tipo:</label>
                <span>{oportunidade.tipo_servico}</span>
              </div>
              <div className="info-item">
                <label>Valor:</label>
                <span className="valor-destaque">{formatarValor(valorVenda)}</span>
              </div>
              <div className="info-item">
                <label>Técnico:</label>
                {oportunidade.tecnico_nome ? (
                  <span>{oportunidade.tecnico_nome}</span>
                ) : (
                  <span style={{color: '#ff9800', fontStyle: 'italic'}}>
                    ⚠️ Não atribuído - Edite no Gestão Click
                  </span>
                )}
              </div>
              {oportunidade.os_id_gestao_click && (
                <div className="info-item">
                  <label>OS Gestão Click:</label>
                  <span>#{oportunidade.os_id_gestao_click}</span>
                </div>
              )}
            </div>
          </div>

          {/* Custos de Terceiros */}
          {oportunidade.status === 'em_execucao' && (
            <div className="info-section">
              <div className="section-header">
                <h3>Custos de Terceiros</h3>
                <button 
                  className="btn-small btn-primary"
                  onClick={() => setMostrarFormCusto(!mostrarFormCusto)}
                >
                  + Adicionar Custo
                </button>
              </div>

              {mostrarFormCusto && (
                <form onSubmit={handleAdicionarCusto} className="form-custo">
                  <div className="form-row">
                    <div className="form-group">
                      <label>Fornecedor/Prestador *</label>
                      <input
                        type="text"
                        value={novoCusto.fornecedor_nome}
                        onChange={(e) => setNovoCusto({...novoCusto, fornecedor_nome: e.target.value})}
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>Valor *</label>
                      <input
                        type="number"
                        step="0.01"
                        value={novoCusto.valor}
                        onChange={(e) => setNovoCusto({...novoCusto, valor: e.target.value})}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group full">
                      <label>Descrição do Serviço *</label>
                      <input
                        type="text"
                        value={novoCusto.servico_descricao}
                        onChange={(e) => setNovoCusto({...novoCusto, servico_descricao: e.target.value})}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>Data Vencimento</label>
                      <input
                        type="date"
                        value={novoCusto.data_vencimento}
                        onChange={(e) => setNovoCusto({...novoCusto, data_vencimento: e.target.value})}
                      />
                    </div>
                    <div className="form-group">
                      <label>Observações</label>
                      <input
                        type="text"
                        value={novoCusto.observacoes}
                        onChange={(e) => setNovoCusto({...novoCusto, observacoes: e.target.value})}
                      />
                    </div>
                  </div>
                  <div className="form-actions">
                    <button type="button" onClick={() => setMostrarFormCusto(false)} className="btn-secondary">
                      Cancelar
                    </button>
                    <button type="submit" className="btn-primary">
                      Adicionar
                    </button>
                  </div>
                </form>
              )}

              <div className="custos-lista">
                {custos.length > 0 ? (
                  custos.map(custo => (
                    <div key={custo.id} className="custo-item">
                      <div className="custo-info">
                        <strong>{custo.fornecedor_nome}</strong>
                        <p>{custo.servico_descricao}</p>
                        {custo.data_vencimento && (
                          <small>Vencimento: {formatarData(custo.data_vencimento)}</small>
                        )}
                      </div>
                      <div className="custo-valor">
                        {formatarValor(custo.valor)}
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-muted">Nenhum custo cadastrado</p>
                )}
              </div>

              {/* Resumo Financeiro */}
              <div className="resumo-financeiro">
                <div className="resumo-row">
                  <span>💰 Valor de Venda:</span>
                  <strong className="text-green">{formatarValor(valorVenda)}</strong>
                </div>
                <div className="resumo-row">
                  <span>💸 Total de Custos:</span>
                  <strong className="text-red">{formatarValor(totalCustos)}</strong>
                </div>
                <div className="resumo-row destaque">
                  <span>📈 Margem:</span>
                  <strong className="text-blue">
                    {formatarValor(margem)} ({percentualMargem}%)
                  </strong>
                </div>
              </div>
            </div>
          )}

          {/* Observações */}
          {oportunidade.descricao && (
            <div className="info-section">
              <h3>Observações</h3>
              <p>{oportunidade.descricao}</p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="btn-secondary">
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default DetalhesModal;
